export default __webpack_public_path__ + "static/media/6_Intro.394280f1.mp4";